import { useEffect, useMemo, type FC, type PropsWithChildren } from 'react';

import { ConnectProvider } from '@particle-network/btc-connectkit';

import { CONNECTOR_ID_FIELD } from '../../constants';

import { getWallets } from './getWallets';

// This workaround moves the particle's btc-connect-kit autoConnect logic to sessionStorage
// Thus the wallet is not reconnected on fresh page load, but only on session reload
(() => {
  const connectorId = sessionStorage.getItem(CONNECTOR_ID_FIELD);

  if (connectorId) {
    localStorage.setItem(CONNECTOR_ID_FIELD, connectorId);
  } else {
    localStorage.removeItem(CONNECTOR_ID_FIELD);
  }
})();

export const BtcProvider: FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    const originalSetItem = localStorage.setItem.bind(localStorage);

    // Pipe the connectorId from localStorage to sessionStorage
    localStorage.setItem = function (k: string, v: string) {
      originalSetItem(k, v);
      if (k === CONNECTOR_ID_FIELD) {
        const connectorId = v;

        if (connectorId) {
          sessionStorage.setItem(CONNECTOR_ID_FIELD, connectorId);
        }
        localStorage.removeItem(CONNECTOR_ID_FIELD);
      }
    };
  }, []);

  const connectors = useMemo(getWallets, []);

  return (
    <ConnectProvider
      options={{
        projectId: '9b83f4ac-a740-4f3a-ad86-435c0f9ebc16', // -
        clientKey: 'crqO6v4TBRjJ8CQ3kHS4LzISP22Fo7cR8bPS5abv', // Retrieved from https://dashboard.particle.network
        appId: 'df4b2547-b4ee-4628-be9a-df586739ba95', // -
        aaOptions: {
          accountContracts: {
            BTC: [
              {
                chainIds: [686868, 28206, 11503, 1501, 1502, 22776, 212, 3110, 1, 11155111, 137, 200901, 200810],
                version: '1.0.0',
              },
              {
                chainIds: [200901, 200810, 3636, 2442, 1123, 223, 5000, 5003, 2648, 111, 60808, 137, 89682],
                version: '2.0.0',
              },
            ],
          },
        },
        walletOptions: { visible: false },
      }}
      connectors={connectors}
      autoConnect
    >
      {children}
    </ConnectProvider>
  );
};
